import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Class } from '../../models/class.model';
import { Schedule } from '../../models/schedule.model';
import { ExtraService } from 'src/app/modules/enrollments/models/extra-service.model';

@Component({
    selector: 'app-classes-selector',
    templateUrl: './classes-selector.component.html',
    styleUrls: ['./classes-selector.component.scss']
})
export class ClassesSelectorComponent implements OnInit {

    @Input() classes: Class[];
    @Input() selectedClasses: Class[];

    @Output() selectedClassesChange = new EventEmitter<Class[]>();

    public labels: any = {
        extraServicesSelectorLabel: 'Seleccione los servicios extras',
        duplicatedAlertMessage: 'No se permite seleccionar el mismo curso en varias semanas. Revise su selección.',
    }

    public showDuplicatedAlertMessage: boolean = false;
    public showClassFullAlertMessage: boolean = false;

    public selectedOptions: { schedule: Schedule, class: Class, extraServices: ExtraService[] }[] = [];

    public classFullAlertMessage: string;

    public schedules: Schedule[];

    ngOnInit(): void {

        this.initData();

    }

    private initData() {

        this.getSchedules();
        this.initSelectedOptions();

    }

    private getSchedules() {

        let allSchedules = [...new Set(this.classes.map(c => c.schedule))];

        this.schedules = allSchedules
            .reduce((schedule, x) => schedule.concat(schedule.find((y: Schedule) => y.scheduleId === x.scheduleId) ? [] : [x]) , [])
            .sort((a: Schedule, b: Schedule) => (a.scheduleId > b.scheduleId ? 1 : -1));

    }

    private initSelectedOptions() {

        this.schedules.forEach(schedule => {

            let option;
            if (this.selectedClasses && this.selectedClasses.length > 0) {

                let scheduleClass = this.selectedClasses.find(sc => sc.scheduleId === schedule.scheduleId);
                option = { schedule: schedule, class: scheduleClass, extraServices: scheduleClass?.extraServices }

            } else {

                option = { schedule: schedule, class: null, extraServices: [] };

            }

            this.selectedOptions.push(option);

        });

    }

    public getSelectedOption(schedule: Schedule) {

        return this.selectedOptions.find(opt => opt.schedule.scheduleId === schedule.scheduleId);

    }

    public getClassesFromSchedule(schedule: Schedule) : Class[] {

        return this.classes.filter(c => c.scheduleId === schedule.scheduleId);

    }

    public onSelectedClassChange(schedule: Schedule) {

        let selectedOptionIndex = this.selectedOptions.findIndex(opt => opt.schedule.scheduleId === schedule.scheduleId);
        if (selectedOptionIndex > -1) {
            this.selectedOptions[selectedOptionIndex].extraServices = [];
        }

        // Generates the result array.
        this.updateSelectedClasses();

    }

    public onExtraCheckboxChange(event: any, schedule: Schedule, extraService: ExtraService) {

        let selectedOptionIndex = this.selectedOptions.findIndex(opt => opt.schedule.scheduleId === schedule.scheduleId);
        if (selectedOptionIndex === -1) { return; }

        if (event.checked) {

            this.selectedOptions[selectedOptionIndex].extraServices.push(extraService);

        } else {

            let extraServiceIndex = this.selectedOptions[selectedOptionIndex].extraServices.findIndex(es => es.extraServiceId === extraService.extraServiceId);
            if (extraServiceIndex === -1) { return; }

            this.selectedOptions[selectedOptionIndex].extraServices.splice(extraServiceIndex, 1);

        }

        // Generates the result array.
        this.updateSelectedClasses();

    }

    private checkForDuplicatedCourses() {

        let selectedCourses = this.selectedOptions.map(so => so.class?.courseId).filter(result => result !== undefined);
        let isAnyCourseDuplicated = selectedCourses.some(function(item, index){
            return selectedCourses.indexOf(item) != index
        });

        return isAnyCourseDuplicated;

    }

    private checkForFullClasses() {

        let selectedClasses = this.selectedOptions.filter(so => so.class !== null).map(so => so.class);

        if (selectedClasses.length === 0) {

            return [];

        } else {

            let fullClasses = selectedClasses.filter(item => item.freePlaces === 0);
            return fullClasses;

        }

    }

    private updateSelectedClasses() {

        this.showDuplicatedAlertMessage = false;
        this.showClassFullAlertMessage = false;
        this.selectedClasses = [];

        let isAnyClassDuplicated = this.checkForDuplicatedCourses();
        let fullClasses = this.checkForFullClasses();

        if (isAnyClassDuplicated) {

            this.showDuplicatedAlertMessage = true;

        } else if (fullClasses.length >= 1) {

            this.showClassFullAlertMessage = true;
            let courseNames = fullClasses.map(item => item.courseName).join(', ');
            this.classFullAlertMessage = `No hay plazas disponibles para las clases de: ${courseNames}`;

        } else {

            this.selectedOptions.forEach(so => {

                let selectedClass = structuredClone(so.class);
                if (selectedClass && selectedClass !== null) {
                    selectedClass.extraServices = structuredClone(so.extraServices);
                    this.selectedClasses.push(selectedClass);
                }

            })

        }

        this.selectedClassesChange.emit(this.selectedClasses);

    }

}
